import { Component } from '@angular/core';
import { SigninComponent, SigninManager } from 'sham-components/shared/auth';
import { WebsiteAdminSigninManager } from '../../../services/signin-manager.service';

@Component({
  selector: 'app-website-admin-signin',
  imports: [SigninComponent],
  templateUrl: './website-admin-signin.html',
  providers: [
    { provide: SigninManager, useClass: WebsiteAdminSigninManager }
  ]
})
export class WebsiteAdminSigninComponent {

}
